import logo from './img/logo.png';
import smallLogo from './img/smallLogo.png';
import userImg from './img/Avatar 3.png';
import avatar from './img/Rectangle.png';
import starImg from './img/star.svg';
import healthLogo from './img/Image.png';
import authorizationBanner from './img/Image25.png';
import authorizationText from './img/Group10.png';
import auxiliumLogo from './img/Image21.png';
import forgotImg from './img/Image28.png';
import emailCheck from './img/Image30.png';
import changePass from './img/Image32.png';
import checkedPass from './img/Image34.png';
import modalImg from './img/Image 9.png';
import defaultImage from './img/default-user.png';
import imagePlaceholder from './img/placeholder.png';
import checkImage from './img/pen.png';
import locationServicesImg from './img/locationservicesimg.png';
import chevronRightSvg from './img/chevron-right.svg';
import sendIcon from './img/send.svg';
import smileIcon from './img/smile.svg';
import personnelDocument from './img/personnel_document.png';
import driver from './img/driver.jpg';
import carPlaceholder from './img/car_placeholder.png';
import noDriverFound from './img/noDriverFound.png';
import contractorPlaceholder from './img/contractor_placeholder.png';

export const IMAGES = {
  checkImage,
  logo,
  smallLogo,
  userImg,
  avatar,
  starImg,
  healthLogo,
  authorizationBanner,
  authorizationText,
  auxiliumLogo,
  forgotImg,
  emailCheck,
  changePass,
  checkedPass,
  modalImg,
  defaultImage,
  imagePlaceholder,
  locationServicesImg,
  chevronRightSvg,
  sendIcon,
  smileIcon,
  personnelDocument,
  driver,
  carPlaceholder,
  noDriverFound,
  contractorPlaceholder,
};
